import React, { useEffect, useState } from 'react';
import { IMarker } from '../../sheard/interfaces/Marker';
import { getMarkers } from '../../sheard/services/TrendSpotterService';
import OverlayLoading from '../Report/OverlayLoading';
import LeafletMap from './LeafletMap';

const TrendSpotter = (props: any) => {
  const [markers, setMarker] = useState<IMarker[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  useEffect(() => {
    try {
      const query = new URLSearchParams(props.location.search);
      const id = query.get('id') || '';
      getMarkers(id).then((res: {data: IMarker[]}) => {
        setMarker(res.data);
        setIsloading(false);
      });
    } catch (error) {
      console.error(error);
      setMarker([]);
      setIsloading(false);
    }
  }, []);

  return <main>
    <div className='location trend-list' style={{position: 'relative', height: '0px'}}>
      <section>
        <header>
          <h2>Location</h2>
        </header>
        <article className='chart' style={{height: '720px', width: '100%', position: 'relative', outline: 'none'}}>
           {isLoading ? <OverlayLoading /> : <LeafletMap markers={markers}></LeafletMap>}
        </article>
      </section>
    </div>
  </main>;
};

export default TrendSpotter;
